import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	generatingSuggestions: {
		id: 'proactive-container.streaming-status-bar.generating-suggestions',
		defaultMessage: 'Generating suggestions',
		description:
			'Alt message of loading icon while Atlassian Intelligence is generating suggestions',
	},
});
